import { CanvasService } from "@services/canvas.service";
import * as angular from "angular";
import "./snow.scss";

interface ISnowflakeArgs {

    w?: number;
    h?: number;

    particleMaxPer: number;
    particleSinus: number[];
    particleOpacity: number[];
    particleSpeed: number[];
    particleSize: number[];

    summer?: number;
}

interface ISnowflake {
    delta?: number,
    alpha?: number,
    speed?: number,
    x?: number,
    y?: number,
    r?: number
}

class Controller implements angular.IComponentController {
    canvas: HTMLCanvasElement;
    ctx: CanvasRenderingContext2D;
    stop: boolean;

    snowflakes?: ISnowflake[];

    platform = { left: 0, width: 0, top: 0 };

    config: ISnowflakeArgs = {
        particleMaxPer: navigator.hardwareConcurrency
            ? Math.floor(navigator.hardwareConcurrency * 100 /*/ 3*/)
            : 100,
        particleSize: [1.5, 6],
        particleOpacity: [.3, 1],
        particleSpeed: [30, 100],
        particleSinus: [1, 100]
    };

    static $inject = ["$element", "$timeout", "canvasService"];

    constructor(
        private readonly $element: JQuery,
        private readonly $timeout: angular.ITimeoutService,
        private readonly canvasService: CanvasService) {
    }

    $onInit() {

        this.snowflakes = [];

        this.canvas = this.$element.find("canvas")[0] as HTMLCanvasElement;
        this.ctx = this.canvas.getContext("2d");

        //console.log(canvas, this.ctx);
        this.config.w = this.$element.outerWidth() || this.canvas.width;
        this.config.h = this.$element.outerHeight() || this.canvas.height;

        this.canvas.width = this.config.w;
        this.canvas.height = this.config.h;

        for (var c = this.config.w * this.config.h / 15E5; this.snowflakes.length < this.config.particleMaxPer * c;) {
            this.snowflakes.push(this.createSnowFlake());
        }

        // On init skip forward a number of frames so we start with snow
        for (var i = 0; i < 200; i++) {
            this.iterateSnowFlakes(false);
        }

        this.animateFrame();

        console.log("Starting snow with", this.config.particleMaxPer, "particles");
    }

    $onDestroy() {
        this.stop = true;

        this.$timeout(() => { 
            this.canvasService.destroyCachedImageCanvases();
        });
    }

    // ---

    private animateFrame() {
        if (this.stop) {
            return;
        }

        window.requestAnimationFrame(() => {
            performance.mark("iterateSnowFlakes");
            this.iterateSnowFlakes();
            performance.measure("iterateSnowFlakes");

            this.animateFrame();
        });
    }

    private iterateSnowFlakes(draw = true) {

        if (draw) {
            this.ctx.clearRect(0, 0, this.config.w, this.config.h);
        }

        var d = this.config.h / 3,
            e = this.config.h / 3 * 2,
            b;

        for (b in this.snowflakes) {
            let snowFlake = this.snowflakes[b];

            if (!(0 > snowFlake.y + .1 * snowFlake.r && 1 == this.config.summer || snowFlake.y > this.config.h + snowFlake.r && 1 == this.config.summer)) {
                // Check for platform hit
                var originalY = snowFlake.y;
                var originalX = snowFlake.x;

                this.snowflakes[b].delta += snowFlake.delta == Math.PI / 2
                    ? -this.snowflakes[b].delta
                    : Math.random() / 500 - .01;

                this.config.summer
                    ? snowFlake.y += this.snowflakes[b].speed / 50 + .1 * this.snowflakes[b].r
                    : snowFlake.y += this.snowflakes[b].speed / 100 + .1 * this.snowflakes[b].r;

                this.snowflakes[b].x += .1 * Math.sin(snowFlake.delta) * this.snowflakes[b].r;
                this.snowflakes[b].y > this.config.h + snowFlake.r && 1 != this.config.summer && (this.snowflakes[b] = this.createSnowFlake(), snowFlake = this.snowflakes[b], this.snowflakes[b].y = 0 - this.snowflakes[b].r);

                var h = snowFlake.y - d,
                    f = snowFlake.r,
                    l = snowFlake.alpha;

                if (0 < h || 1 == this.config.summer) h = 1 - h / e,
                    f = this.snowflakes[b].r * h,
                    l = this.snowflakes[b].alpha * h;

                f = .1 > f ? .1 : f;
                l = .1 > l ? .1 : l;

                this.snowflakes[b].x = this.snowflakes[b].x > this.config.w + this.snowflakes[b].r
                    ? 0
                    : this.snowflakes[b].x < -f
                        ? this.config.w
                        : this.snowflakes[b].x;

                if (this.snowflakes[b].x >= this.platform.left && this.snowflakes[b].x < this.platform.left + this.platform.width && this.snowflakes[b].y /*+ 10*/ + Math.ceil(this.snowflakes[b].r + 1.5) > this.platform.top) {
                    this.snowflakes[b].x = originalX;
                    this.snowflakes[b].y = originalY;
                    this.snowflakes[b].y = originalY + 0.04;

                    //this.snowflakes[b].y -= 1;
                    this.snowflakes[b].alpha -= 0.002;
                    if (this.snowflakes[b].alpha <= 0) {
                        this.snowflakes[b] = this.createSnowFlake();
                    }
                }

                if (draw) {
                    this.drawSnowFlake(this.snowflakes[b], l, f);
                }
            }
        }
    }

    private drawSnowFlake(snowflake: ISnowflake, alpha: number, radius: number) {
        if (typeof radius === "undefined") {
            return;
        }

        ////return;

        //console.log("drawSnowFlake", snowflake.x, snowflake.y, radius, Math.ceil(radius * 2));

        var useNewFancy = false;

        if (useNewFancy) {
            var diameter = Math.ceil(radius * 2);
            var imageCanvas = this.canvasService.getCachedImageCanvas(diameter, diameter);
            if (!imageCanvas) {
                imageCanvas = this.canvasService.createCachedImageCanvas(diameter, diameter);
                var cachedCtx = imageCanvas.getContext("2d");

                cachedCtx.beginPath();
                cachedCtx.arc(radius, radius, radius, 2 * Math.PI, 0);
                cachedCtx.fillStyle = "white";
                cachedCtx.fill();

                //console.log("cache miss", radius, diameter);
            }

            this.ctx.globalAlpha = alpha;
            this.ctx.drawImage(imageCanvas, snowflake.x, snowflake.y);
        }
        else {
            this.ctx.beginPath();
            this.ctx.arc(snowflake.x, snowflake.y, radius, 2 * Math.PI, 0);
            this.ctx.fillStyle = "rgba(255,255,255," + alpha + ")";
            this.ctx.fill();
        }
    }

    private createSnowFlake(): ISnowflake {

        var snowflake: ISnowflake = {
            delta: (this.config.particleSinus[0] + Math.random() * (this.config.particleSinus[1] - this.config.particleSinus[0])) * Math.round(2 * Math.random() - 1),
            r: this.config.particleSize[0] + Math.random() * (this.config.particleSize[1] - this.config.particleSize[0]),
            alpha: this.config.particleOpacity[0] + Math.random() * (this.config.particleOpacity[1] - this.config.particleOpacity[0]),

            x: Math.random() * this.config.w,
            y: Math.random() * -this.config.h,
        };

        snowflake.speed = (this.config.particleSpeed[0] + Math.random() * (this.config.particleSpeed[1] - this.config.particleSpeed[0])) * snowflake.r / 3;

        return snowflake;
    }
}

export class SnowComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;

    constructor() {
        this.bindings = {
        };

        this.controller = Controller;
        this.template = "<canvas></canvas>";
    }
}
